import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import config from '@app/configs/au-main-config';
import { AuErrorAdapter, AuGqlError } from '@app/shared';
import { IconSnackBarService } from '@core/services/icon-snack-bar.service';

interface IErrorData {
	error: AuGqlError;
	dontPrintToConsole?: boolean;
	defaultMessage?: string;
}

@Injectable({
	providedIn: 'root',
})
export class AuErrorService {
	constructor(
		private router: Router,
		private notify: IconSnackBarService
	) {}

	goToErrorPageAndShowError(error: AuGqlError): void {
		this.router.navigate([config.auRoutes.errorPage.link], {
			state: { title: AuErrorAdapter.getTextFromGqlError(error) },
		});
	}

	notifyUserAboutError(errorData: IErrorData): void {
		if (!errorData.dontPrintToConsole) {
			AuErrorAdapter.printGqlErrorToConsole(errorData.error);
		}

		this.notify.error(
			AuErrorAdapter.getTextFromGqlError(errorData.error, errorData.defaultMessage)
		);
	}
}
